import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=41444838
const initialState: {
  order_id?: string
  pub_key?: string
  account: IProfileResp
} = {
  account: {
    diamonds: 0,
    recharge_agency_info: {
      is_recharge_agency: false,
      is_coin_public: false,
      trade_remark: '',
    },
  },
}

// http://wiki.xunlei.cn/pages/viewpage.action?pageId=110332023
export const checkout_get_ext_info = createAsyncThunk(
  '/live/pay/ckot_get_ext_info',
  async (order_id: string, store) => {
    const resp = await http.post<HiyaRes<typeof initialState>>(
      '/live/pay/ckot_get_ext_info',
      store.getState().env.deviceinfo
    )
    return resp.data.data
  }
)

// http://wiki.xunlei.cn/pages/viewpage.action?pageId=110332036
export const create_checkout_order = createAsyncThunk(
  '/live/pay/create_ckot_order',
  async (
    data: {
      order_id: string
      token: string
      event: any
      recharge_type: number
    },
    store
  ) => {
    const resp = await http.post<
      HiyaRes<{
        redirect_url: string
      }>
    >('/live/pay/create_ckot_order', {
      ...store.getState().env.deviceinfo,
      ...data,
    })
    return resp.data.data
  }
)

export type IProfileResp = {
  /** int64，金币余额 */
  diamonds: number
  recharge_agency_info: {
    /** 是否币商 */
    is_recharge_agency: boolean
    /** 是否公开金币余额  */
    is_coin_public: boolean
    /** 交易说明 */
    trade_remark: string
  }
}
export const getProfile = createAsyncThunk(
  '/live/account/profile',
  async (params, store: any) => {
    const resp = await http.post<{data: IProfileResp}>(
      '/live/account/profile',
      {
        ...store.getState().env.deviceinfo,
      }
    )

    return resp.data.data
  }
)

export const Wallet2CheckoutSlice = createSlice({
  name: 'Wallet2Checkout',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(checkout_get_ext_info.fulfilled, (state, action) => {
      Object.assign(state, {
        ...action.payload,
        order_id: action.meta.arg,
      })
    })

    builder.addCase(getProfile.fulfilled, (state, action) => {
      const {diamonds, recharge_agency_info} = action.payload
      Object.assign(state.account, {
        diamonds,
        recharge_agency_info,
      })
    })
  },
})
export const Wallet2CheckoutSliceActions = Wallet2CheckoutSlice.actions
export default Wallet2CheckoutSlice.reducer
export const useWallet2CheckoutState = () => {
  const data = useSelector((state) => state.Wallet2Checkout)
  return data
}
